import { createSlice } from "@reduxjs/toolkit";

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    adminDetails: [],
    clientBrands: null,
    openDrawer: false,
    permissions: [],
    fullPageLoader: false,
    findValues: {
      navBarHeight: 0,
    },
    pendingGenders: {},
  },
  reducers: {
    updateAdminDetails: (state, action) => {
      state.adminDetails = [action.payload].flat();
    },
    updateClientBrands: (state, action) => {
      state.clientBrands = action.payload;
    },
    updateDrawer: (state, action) => {
      state.openDrawer = !state.openDrawer;
    },
    updatePermission: (state, action) => {
      state.permissions = action.payload;
    },

    updateLoader: (state, action) => {
      state.fullPageLoader = !state.fullPageLoader;
    },

    updateFindValues: (state, action) => {
      state.findValues = {
        ...state.findValues,
        ...action.payload,
      };
    },

    setPendingGender: (state, action) => {
      const { providerId, value } = action.payload;
      state.pendingGenders = { ...state.pendingGenders, [providerId]: value };
    },

    clearPendingGender: (state, action) => {
      const { [action.payload]: _, ...rest } = state.pendingGenders;
      state.pendingGenders = rest;
    },
  },
});

export const {
  updateAdminDetails,
  updateClientBrands,
  updateDrawer,
  updatePermission,
  updateLoader,
  updateFindValues,
  setPendingGender,
  clearPendingGender,
} = adminSlice.actions;
export default adminSlice.reducer;
